import react, { useEffect, useState } from 'react'
import { MdOutlinePerson } from 'react-icons/md'
import styled from 'styled-components'
import Job from '../../Common/Job'
import { MdSettings } from 'react-icons/md'
import Group from '../../Common/Group'
import Reply from '../../Common/Reply'
import { Mentor } from '../../../models/User'
import { JobInfoRecommend } from '../../../models/JobRecommend'
import { MentorJobInfoRecommend } from '../../../models/Dto/MentorJobInfoRecommend'
import { asyncGetFriends } from '../../../store/mainSlice'
import { RootState, useAppDispatch, useAppSelector } from '../../../store'
import { FriendToUser } from '../../../models/FriendToUser'

type Props = {
  selectedMentors: Mentor[]
  mentorJobInfoRecommends: MentorJobInfoRecommend[]
  onChangeToInventory?: (jobId: number, isAdd: boolean) => void
}

function Main(props: Props) {
  const [recommendCount, setRecommendCount] = useState(0)
  const friends = useAppSelector((state: RootState) => state.main.friends)
  const me = useAppSelector((state: RootState) => state.user.me)
  const dispatch = useAppDispatch()

  const initialLoadFriends = async () => {
    try {
      await dispatch(asyncGetFriends(me.id))
    } catch (error) {}
  }

  useEffect(() => {
    initialLoadFriends()
  }, [])

  useEffect(() => {
    setRecommendCount(
      props.mentorJobInfoRecommends.reduce((acc, cur) => {
        return acc + cur.jobInfoRecommends.length
      }, 0)
    )
  }, [props.mentorJobInfoRecommends])

  const getFriend = (id: number): FriendToUser | undefined => {
    return friends.find((f) => f.friend.id === id)
  }

  return (
    <Container>
      <MainTitle>추천직업</MainTitle>

      {props.mentorJobInfoRecommends.map(
        (mentorJobInfoRecommend: MentorJobInfoRecommend, index) => (
          <div key={index}>
            {mentorJobInfoRecommend.jobInfoRecommends.length > 0 && (
              <Title>
                {mentorJobInfoRecommend.isMentor
                  ? mentorJobInfoRecommend.mentor?.mentor.username +
                    ' 멘토 추천직업'
                  : '친구 추천직업'}
              </Title>
            )}
            <Items>
              {mentorJobInfoRecommend.jobInfoRecommends.map(
                (jobInfoRecommend: JobInfoRecommend) => (
                  <Item key={jobInfoRecommend.id}>
                    <Job
                      id={jobInfoRecommend.job.id}
                      image={jobInfoRecommend.job.photo}
                      name={jobInfoRecommend.job.name}
                      description={jobInfoRecommend.job.overview}
                      isInInventory={jobInfoRecommend.job.isInInventory}
                      onChangeToInventory={props.onChangeToInventory}
                    />

                    <Reply
                      name={
                        // mentorJobInfoRecommend.mentor?.mentor.username ??
                        getFriend(jobInfoRecommend.sendUserId)?.friend
                          ?.username ?? ''
                      }
                      description={jobInfoRecommend.recommendContent}
                    />
                  </Item>
                )
              )}
            </Items>
          </div>
        )
      )}
    </Container>
  )
}

const Container = styled.div`
  grid-area: main;
  margin-bottom: 1rem;
`

const MainTitle = styled.div`
  font-size: 1.2rem;
`
// styled-components
const Title = styled.div`
  padding: 10px 20px;
  margin: 10px 0;
  background-color: orange;
  font-weight: 500;
  color: white;
`
const Items = styled.div``

const Item = styled.div`
  padding-bottom: 1.5rem;
`
export default Main
